import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces'
import { getCustomerOpportunities } from '../../customers'

export default function useCustomerOpportunities(
  query: DetailPaginatedRequest
) {
  const { data, error, isLoading } = useQuery(
    ['customerOpportunities', query],
    () => getCustomerOpportunities(query)
  )
  return { data, error, isLoading }
}
